import { IconProps } from './types';

const QuestionMark = ({ className, strokeWidth }: IconProps) => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            strokeWidth={strokeWidth}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM10.5 11.25C10.5 10.8358 10.8358 10.5 11.25 10.5C11.6478 10.5 12.0294 10.658 12.3107 10.9393C12.592 11.2206 12.75 11.6022 12.75 12V15.75C13.1642 15.75 13.5 16.0858 13.5 16.5C13.5 16.9142 13.1642 17.25 12.75 17.25C12.3522 17.25 11.9706 17.092 11.6893 16.8107C11.408 16.5294 11.25 16.1478 11.25 15.75V12C10.8358 12 10.5 11.6642 10.5 11.25ZM12.75 7.875C12.75 8.49632 12.2463 9 11.625 9C11.0037 9 10.5 8.49632 10.5 7.875C10.5 7.25368 11.0037 6.75 11.625 6.75C12.2463 6.75 12.75 7.25368 12.75 7.875Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default QuestionMark;
